import { graphql } from "@/api/graphql/types/gql.ts";

export const toggleFormDataRuleGroupMutation = graphql(`
  mutation ToggleFormDataRuleGroup($id: ID!) {
    MiddleMsToggleFormDataRuleGroup(request: { id: $id }) {
      enabled
    }
  }
`);
